export default {
  nav: {
    reserve: 'Reservar Agora',
    cart: 'Carrinho',
    menu: 'Menu',
    language: 'Idioma',
    about: "Sobre Nós",
    contact: "Contato",
    categories: "Categorias de passeios",
  },
  hero: {
    line1: 'Escunas, trilhas e aventuras em',
    line2: 'Paraty',
    subtitle: 'Passeios de escuna, lanchas privativas, jeep tour e mergulho.',
    subtitleHighlight: 'Experiências únicas',
    ctaTours: 'Ver Passeios',
    ctaContact: 'Contactar',
    scroll: 'Explorar',
    statYears: 'Anos de Experiência',
    statGuests: 'Passageiros Felizes',
    statBeaches: 'Praias e Ilhas',
  },
  tours: {
    label: 'Nossos Passeios',
    title: 'Descubra o melhor de Paraty',
    subtitle: 'Passeios cuidadosamente selecionados para você aproveitar cada momento.',
    duration: 'Duração',
    difficulty: 'Dificuldade',
    from: 'A partir de',
    details: 'Ver Detalhes',
    seeAll: 'Ver todos os passeios',
    limited: 'Vagas Limitadas',
    fewLeft: 'Poucas vagas',
    flashDeal: 'Oferta Relâmpago',
    offerEnds: 'Oferta termina em:',
    offerPrice: 'Preço Oferta',
    stillOffer: 'Ainda em oferta!',
    categories: {
      all: 'Todos',
      escunas: 'Escunas',
      jeep: 'Passeios de Jeep',
      compartilhadas: 'Lanchas Compartilhadas',
      privadas: 'Lanchas e Escunas Privadas',
      bolivia: 'Expedição Bolívia 🇧🇴',
    },
  },
  why: {
    label: 'Por que escolher a AQUAMARINA?',
    title: 'Uma experiência que vai além do passeio',
    pillars: {
      safety: 'Segurança em primeiro lugar',
      guides: 'Guias locais experientes',
      boats: 'Embarcações de qualidade',
      price: 'Preço justo e transparente',
    },
  },
  testimonials: {
    label: 'Depoimentos',
    title: 'O que nossos passageiros dizem',
    subtitle: 'Experiências reais de quem já navegou com a gente.',
  },
  faq: {
    label: 'Dúvidas Frequentes',
    title: 'Perguntas & Respostas',
    subtitle: 'Tudo o que você precisa saber antes de embarcar.',
  },
  contact: {
    label: 'Reserve sua aventura',
    title: 'Contato & Reservas',
    subtitle: 'Pronto para mergulhar em uma experiência inesquecível?',
    form: {
      name: 'Nome completo',
      email: 'E-mail',
      phone: 'WhatsApp',
      date: 'Data do passeio',
      message: 'Conte-nos sobre sua aventura ideal',
      submit: 'Enviar mensagem',
      sending: 'Enviando...',
      successTitle: 'Mensagem enviada!',
      successText: 'Em breve nossa equipe entrará em contato.',
    },
    location: 'Onde estamos',
    attendance: 'Atendimento',
    schedule1: 'Segunda a Sábado: 08h às 20h',
    schedule2: 'Domingo: 09h às 17h',
    email: 'paraty.sirenatours@gmail.com',
    whatsappLabel: 'Atendimento rápido',
    address: 'Av. Roberto Silveira 578, Centro — Paraty, RJ',
    mapLink: 'Ver no Google Maps',
  },
  bolivia: {
    badge: 'Oferta de Abertura',
    title: 'Descubra a Bolívia com Nos',
    subtitle: 'Explore o maior deserto de sal do mundo, lagoas coloridas, vulcões e paisagens de outro mundo no Altiplano Boliviano.',
    cta: 'Conheça a Expedição',
    seeAll: 'Ver todos os passeios',
    highlights: ['3 Dias / 2 Noites', 'Grupo Reduzido', 'Guia Experiente', 'Tudo Incluso'],
    openingOffer: 'Preço de Abertura',
    promoBadge: 'Preço Promocional',
    promoPrice: 'Preço Promocional',
    price: 'R$ 1.200',
    originalPrice: 'R$ 1.500',
    perPerson: 'por pessoa',
    allIncluded: 'Tudo Incluso',
    includedTitle: 'O que está incluso',
    accommodation: 'Hospedagem 2 noites',
    meals: 'Todas as refeições',
    transport: 'Transporte 4x4',
    guide: 'Guia experiente',
    sunset: 'Pôr do sol no Salar',
    flamingos: 'Flamingos & Lagoas',
    newActivity: 'NOVA ATIVIDADE',
    newActivityDesc: 'Degustação de vinhos bolivianos de altitude no pôr do sol',
  },
  footer: {
    rights: 'Todos os direitos reservados.',
    company: 'AQUAMARINA TOURS',
    tagline: 'Experiências oceânicas únicas em Paraty',
    links: {
      home: 'Início',
      tours: 'Passeios',
      contact: 'Contato',
      terms: 'Termos e Condições',
      privacy: 'Política de Privacidade',
    },
  },
  category: {
    back: 'Início',
    emptyTitle: 'Nenhum passeio encontrado',
    emptyText: 'Nenhum passeio encontrado nesta categoria no momento.',
    ctaAll: 'Ver todos os passeios',
  },
  booking: {
    reserve: 'Reserve seu passeio',
    date: 'Data do passeio',
    adults: 'Adultos (10+ anos) — Valor integral',
    children: 'Crianças (5 a 9 anos) — Metade do valor',
    babies: 'Bebês (0 a 4 anos) — Cortesia',
    adultPrice: 'cada',
    childPrice: 'cada',
    babyPrice: 'Grátis',
    total: 'Total estimado',
    addCart: 'Adicionar à sacola',
    added: 'Adicionado!',
    cartSuccess: 'Passeio adicionado à sacola!',
    reserveNow: 'Reservar agora',
    pixTitle: 'Como funciona a reserva?',
    pixText1: 'Para concluir a reserva, você precisa fazer o pagamento de um sinal via PIX.',
    pixText2: 'O restante do pagamento é feito no dia do passeio, diretamente no local de embarque.',
    pixText3: 'Após o pagamento do sinal, enviaremos o voucher com todas as informações.',
    whatsappCta: 'Continuar reserva pelo WhatsApp',
    back: 'Voltar',
    selectDateAlert: 'Por favor, selecione uma data para o passeio.',
    whatsappModal: {
      title: 'Confirmar Reserva',
      totalTours: 'Total de passeios',
      totalPeople: 'Total de pessoas',
      grandTotal: 'Valor total estimado',
      fullName: 'Seu nome completo',
      fullNamePlaceholder: 'Ex: João Silva',
      priceReference: 'Valores de Referência',
      perPerson: 'Por pessoa',
      startingFrom: 'A partir de',
      warningTitle: '⚠️ Atenção! Leia antes de continuar',
      warning1: 'Você será redirecionado para o WhatsApp com todos os detalhes dos passeios, quantidade de pessoas, datas e valores.',
      warning2: 'O valor do sinal via PIX será informado pela nossa equipe no WhatsApp conforme os passeios selecionados.',
      warning3: 'O pagamento do restante é feito no dia do passeio, diretamente no local de embarque.',
      warning4: 'Após o pagamento do sinal, enviaremos o voucher com todas as informações da sua reserva.',
      acceptTerms: 'Li e aceito. Entendo que serei redirecionado para o WhatsApp para finalizar a reserva.',
      acceptAndGo: 'Aceitar e ir para WhatsApp',
      cancel: 'Cancelar',
      nameRequired: 'Por favor, digite seu nome completo para continuar.',
    },
  },
  cart: {
    title: 'Sua Sacola',
    empty: 'Sua sacola está vazia',
    emptyCta: 'Explorar passeios',
    itemAdults: 'Adultos',
    itemChildren: 'Crianças',
    itemBabies: 'Bebês',
    remove: 'Remover',
    total: 'Total estimado',
    continue: 'Continuar reservando',
    reserveAll: 'Reservar tudo pelo WhatsApp',
  },
  notFound: {
    title: 'Página não encontrada',
    back: 'Voltar para o início',
  },
  tour: {
    about: 'Sobre este passeio',
    itinerary: 'Itinerário do dia',
    included: 'O que está incluso',
    notIncluded: 'Não está incluso',
    bring: 'O que levar',
    info: 'Informações práticas',
    policy: 'Política, Termos & Avisos Importantes',
    importantNotes: 'Avisos importantes',
    cancellation: 'Política de cancelamento',
    cancellationPolicy: "Com 7 dias ou mais de antecedência: reembolso de 100%. Entre 7 dias e 48 horas antes do passeio: retenção de 20% (reembolso de 80%). Com menos de 48 horas ou não comparecimento (no-show): sem reembolso. Se a empresa cancelar por segurança ou mau tempo: reembolso de 100%.",
    terms: 'Termos e condições',
    meetingPoint: 'Ponto de encontro',
    startTime: 'Horário de início',
    duration: 'Duração',
    difficulty: 'Dificuldade',
    groupSize: 'Tamanho do grupo',
    related: 'Passeios que você também pode gostar',
    reviews: 'Avaliações Reais',
    reviewsSubtitle: 'Depoimentos de quem já viveu essa experiência com a AQUAMARINA.',
    back: 'Voltar',
    tab: {
      descricao: 'Descrição',
      roteiro: 'Roteiro',
      incluso: 'O que está incluso',
      levar: 'O que levar',
      info: 'Informações',
      politica: 'Política',
    },
    gallery: {
      prev: 'Imagem anterior',
      next: 'Próxima imagem',
      viewPhoto: 'Ver foto',
    },
  },
};
